<template>
	<v-dialog v-model="changeStoreDialog" width="600px">
    <customDialog>
      <template v-slot:title>
        {{t('selectStore')}}
        <button id="dialog_exit" @click="changeStoreDialog = false">
          <img src="@/assets/images/popup_close.png" id="btn_img">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 pt-7 pb-10 dialog_text" align="center">
              <v-col class="ma-0 pa-0 pb-2" cols="auto">
                {{t('currentStore')}} : {{selectedUnisCustomerName}}
              </v-col> 
            </v-row>
            <v-radio-group v-model="selectedUnisCustomerCd" class="pb-6">
              <v-radio
                v-for="store in selectableUnisCustomerCdList"
                :key="store.unisCustomerCd"
                :label="store.unisCustomerName"
                :value="store.unisCustomerCd"
                :class="['custom-radio', { 'selected-radio': selectedUnisCustomerCd === store.unisCustomerCd }]"
                color="primary"
                @change="clickStore(store.unisCustomerCd, store.umid)"
              ></v-radio>
            </v-radio-group>
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
             	<!-- <v-btn class="ma-0 pa-0" id="grey_btn" width="8rem" height="2rem"
						 		@click="changeStoreDialog = false">{{t('cancel')}}</v-btn> -->
             	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" width="8rem" height="2rem"
							 	@click="selectStore" :loading="loading">{{t('selectStore')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';

export default {
	props: {
		dialogVisible: Boolean,
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
		changeStoreDialog: false,
		selectedUnisCustomerCd: '', 
    selectedUmid: '',
    selectedUnisCustomerName: '',
		loading: false,
	}),
	computed: {
    selectableUnisCustomerCdList() {
      return this.$store.getters.getSelectableUnisCustomerCdList;
    }
	},
	watch: {
		dialogVisible: function(isVisible) {
      if (isVisible) {
        this.selectedUnisCustomerCd = this.$store.getters.getSelectedUnisCustomerCd;
        this.selectedUmid = this.$store.getters.getSelectedUnisCustomerUmid;
        const findStore = this.$store.getters.getSelectableUnisCustomerCdList.find(item => item.unisCustomerCd === this.selectedUnisCustomerCd)
        if (findStore) this.selectedUnisCustomerName = findStore.unisCustomerName;
      }
      this.loading = false;
			this.changeStoreDialog = isVisible;
		},
		changeStoreDialog: function(item) {
			this.$emit('visible', item);
		},
	},
  methods: {
    clickStore(unisCustomerCd, umid) {
      this.selectedUnisCustomerCd = unisCustomerCd;
      this.selectedUmid = umid;
    },
		selectStore() {
      if (!this.selectedUnisCustomerCd || !this.selectedUmid) {
        this.showToastMessage(this.tmb('canNotChangeStoreCurrent'));
        return;
      }
      this.$emit('store-selected', this.selectedUnisCustomerCd, this.selectedUmid);
      this.loading = true;
		}
  }
}
</script>

<style lang="scss" scoped>
.custom-radio {
  border: 2px solid #e0e7ef;
  border-radius: 10px;
  margin-bottom: 16px;
  background: #fff;
  transition: background 0.2s, border 0.2s;
  min-height: 64px;         // 높이 늘리기
  display: flex;
  align-items: center;
  padding: 0 24px;          // 좌우 여백
  font-size: 1.2rem;        // 글씨 크기 약간 키우기
}
.selected-radio {
  background: #eaf4fe !important;
  border: 2px solid #2196f3 !important;
}
</style>